import { CATALOG } from './catalog'
import { join, type BrickSet } from './sets-shared'
import { loadGeneratedSet } from './data/generated-lazy'

// Resolved once per slug, then reused: a hover/idle preload
// (Library.tsx's `preloadReader`) and the reader's own mount both call
// this for the same set, and the second call should hit the first's
// in-flight promise rather than re-fetch.
const cache = new Map<string, Promise<BrickSet | null>>()

// A set's full build data (steps, parts, notes), loaded as its own chunk
// instead of the whole catalog. This is the client-safe counterpart to
// `sets.ts`'s `getSet` — that one is synchronous because the server already
// has every set in memory; this one fetches because the browser shouldn't.
export function loadBrickSet(slug: string): Promise<BrickSet | null> {
  let promise = cache.get(slug)
  if (!promise) {
    const copy = CATALOG.find((c) => c.slug === slug)
    promise = copy
      ? loadGeneratedSet(slug)
          .then((data) => join(copy, data))
          .catch(() => null)
      : Promise.resolve(null)
    cache.set(slug, promise)
  }
  return promise
}

// The 3D build view only ever needs a set's model URL, which is the slug
// itself (scripts/bricks/pack-parts.ts bakes it to
// public/bricks/models/<slug>.ldr) — no need to load the set's data for it.
export function modelUrl(slug: string) {
  return `/bricks/models/${slug}.ldr`
}
